import { render, staticRenderFns } from "./RegistrationActionSet.vue?vue&type=template&id=17ef0b3a&scoped=true&"
import script from "./RegistrationActionSet.vue?vue&type=script&lang=ts&"
export * from "./RegistrationActionSet.vue?vue&type=script&lang=ts&"
import style0 from "./RegistrationActionSet.vue?vue&type=style&index=0&id=17ef0b3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ef0b3a",
  null
  
)

export default component.exports